import hostname from "./config.host";
import { fetchWrapper } from "./fetch-wrapper";
const apiUrl: string = `${hostname}/aladdin_api/v1`;

function postAnalyticsTracking(data: any, oauthTokenHeader: string) {
  return fetchWrapper.post(
    `${apiUrl}/utilities/track/`,
    data,
    oauthTokenHeader
  );
}

export const trackingAnalyticsService = {
  postAnalyticsTracking,
};
